var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhyInvestIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "why-invest-icon-2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M0,0H24V24H0ZM0,0H24V24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M13.12,2.06,7.58,7.6A2,2,0,0,0,7,9.01V19a2.006,2.006,0,0,0,2,2h9a2.014,2.014,0,0,0,1.84-1.21l3.26-7.61A3,3,0,0,0,20.34,8H14.69l.95-4.58a1.508,1.508,0,0,0-.41-1.37,1.488,1.488,0,0,0-2.11.01ZM3,21a2.006,2.006,0,0,0,2-2V11a2,2,0,0,0-4,0v8A2.006,2.006,0,0,0,3,21Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyInvestIcon2);
export default __webpack_public_path__ + "static/media/why-invest-icon-2.1f430a1b642d284dd0254e6b5027afad.svg";
export { ForwardRef as ReactComponent };